import { render, staticRenderFns } from "./ClientProduct.vue?vue&type=template&id=7ca7c5fe"
import script from "./ClientProduct.vue?vue&type=script&lang=js"
export * from "./ClientProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports